"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "main-container block" };
const _hoisted_2 = { class: "date-pickers flex w-fit items-end mb-5" };
const _hoisted_3 = { class: "mr-3" };
const _hoisted_4 = { class: "new-appointment-container" };
const _hoisted_5 = { class: "appointment-head" };
const _hoisted_6 = { class: "home-title" };
const ExcludedDayItem_vue_1 = __importDefault(require("./ExcludedDayItem.vue"));
const vue_3 = require("vue");
const CompanyLocationStore_1 = require("../../../stores/backend/company/CompanyLocationStore");
const offDaysStore_1 = require("../../../stores/backend/offDays/offDaysStore");
const vue_datepicker_1 = __importDefault(require("@vuepic/vue-datepicker"));
require("@vuepic/vue-datepicker/dist/main.css");
const Form_1 = require("../../../components/Form");
const CustomButton_vue_1 = __importDefault(require("../../../components/backend/CustomButton.vue"));
const date_fns_1 = require("date-fns");
const i18n_1 = __importDefault(require("../../../common/i18n"));
const Alert_vue_1 = __importDefault(require("../../../components/Alert.vue"));
const i18n_2 = require("../../../common/i18n");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ExcludedDays',
    setup(__props) {
        const currentLang = (0, vue_3.computed)(() => i18n_2.i18n.locale.value);
        const companyLocationStore = (0, CompanyLocationStore_1.useCompanyLocationStore)();
        const offDaysStore = (0, offDaysStore_1.useOffDaysStore)();
        const showAlert = (0, vue_3.ref)(false);
        const isError = (0, vue_3.ref)(false);
        (0, vue_3.onBeforeMount)(() => {
            if (companyLocationStore.selectedLocation &&
                companyLocationStore.selectedLocation.id) {
                offDaysStore.getOffDays(companyLocationStore.selectedLocation.id);
            }
        });
        //const activeDatePicker = ref<String | null>(null);
        const selectedFromDate = (0, vue_3.ref)(new Date(new Date().setHours(0, 0, 0, 0)));
        const selectedToDate = (0, vue_3.ref)(new Date(new Date().setHours(0, 0, 0, 0)));
        const handleFromDateChange = (date) => {
            selectedFromDate.value = new Date(date.setHours(0, 0, 0, 0));
        };
        const handleToDateChange = (date) => {
            selectedToDate.value = new Date(date.setHours(0, 0, 0, 0));
        };
        function checkDates(dateFrom, dateTo) {
            let today = new Date();
            today = new Date(today.setHours(0, 0, 0, 0));
            if (dateFrom < today) {
                alert(i18n_1.default.trans("excluded_days_invalid_from_date", "From date cannot be less than today", "excluded_days"));
                return false;
            }
            else if (dateTo < dateFrom) {
                alert(i18n_1.default.trans("excluded_days_invalid_dates", "From date cannot be greater than date to", "excluded_days"));
                return false;
            }
            return true;
        }
        const saveDates = async () => {
            var _a, _b;
            if (!checkDates(selectedFromDate.value, selectedToDate.value)) {
                return false;
            }
            const result = await offDaysStore.addExcludedDaysInterval(selectedFromDate.value, selectedToDate.value, (_b = (_a = companyLocationStore.selectedLocation) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : 0);
            if (typeof result.success !== "undefined" && result.success) {
                showAlert.value = true;
                setTimeout(() => {
                    showAlert.value = false; // 5 mp után elrejtjük
                }, 5000);
            }
            else {
                isError.value = true;
                setTimeout(() => {
                    isError.value = false; // 5 mp után elrejtjük
                }, 5000);
            }
        };
        //reload off days if company or location is changed
        (0, vue_3.watch)([
            () => { var _a; return (_a = companyLocationStore.selectedLocation) === null || _a === void 0 ? void 0 : _a.id; },
            () => { var _a; return (_a = companyLocationStore.selectedCompany) === null || _a === void 0 ? void 0 : _a.id; },
        ], ([locId, compId], [oldLocId, oldCompId]) => {
            if (locId || compId) {
                offDaysStore.getOffDays(companyLocationStore.selectedLocation.id);
            }
        }, { immediate: false });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (showAlert.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Alert_vue_1.default, {
                        key: 0,
                        message: _ctx.$trans('excluded_days_saved_success_message', 'Dates saved succesfully.', 'excluded_days_date_from'),
                        variant: "success",
                        class: "rounded-t-none",
                        "icon-class": "marso-icon-check"
                    }, null, 8, ["message"]))
                    : (0, vue_2.createCommentVNode)("", true),
                (isError.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Alert_vue_1.default, {
                        key: 1,
                        message: _ctx.$trans('excluded_days_saved_error_message', 'Something bad happened. Can\'t save the dates.', 'excluded_days_date_from'),
                        variant: "danger",
                        class: "rounded-t-none",
                        "icon-class": "marso-icon-exclamation-circle"
                    }, null, 8, ["message"]))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_datepicker_1.default), {
                            ref: "dpRefDate",
                            "time-picker-inline": "",
                            class: "date-picker mr-5",
                            locale: currentLang.value,
                            "show-buttons": false,
                            clearable: false,
                            "enable-time-picker": false,
                            "auto-apply": "",
                            "close-on-scroll": "",
                            onOpen: () => 'date',
                            "onUpdate:modelValue": handleFromDateChange
                        }, {
                            trigger: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                    name: "date_from",
                                    label: '*' +
                                        _ctx.$trans('date_from', 'Date from', 'excluded_days_date_from'),
                                    "model-value": (0, vue_2.unref)(date_fns_1.format)(selectedFromDate.value, 'yyyy.MM.dd')
                                }, null, 8, ["label", "model-value"])
                            ]),
                            _: 1
                        }, 8, ["locale"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(vue_datepicker_1.default), {
                            ref: "dpRefDate",
                            "time-picker-inline": "",
                            class: "date-picker mr-5",
                            locale: currentLang.value,
                            "show-buttons": false,
                            clearable: false,
                            "enable-time-picker": false,
                            "auto-apply": "",
                            "close-on-scroll": "",
                            onOpen: () => 'date',
                            "onUpdate:modelValue": handleToDateChange
                        }, {
                            trigger: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                    name: "date_to",
                                    label: '*' +
                                        _ctx.$trans('date_to', 'Date to', 'excluded_days_date_to'),
                                    "model-value": (0, vue_2.unref)(date_fns_1.format)(selectedToDate.value, 'yyyy.MM.dd')
                                }, null, 8, ["label", "model-value"])
                            ]),
                            _: 1
                        }, 8, ["locale"]),
                        (0, vue_2.createVNode)(CustomButton_vue_1.default, {
                            "btn-type": "success",
                            "custom-class": "save-btn-important",
                            onClick: saveDates
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("span", _hoisted_3, (0, vue_2.toDisplayString)(_ctx.$trans("date_save", "Save", "excluded_days_date_save")), 1)
                            ]),
                            _: 1
                        })
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            (0, vue_2.createElementVNode)("div", _hoisted_6, (0, vue_2.toDisplayString)(_ctx.$trans("excluded_days", "Excluded days", "excluded_days")), 1)
                        ]),
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(offDaysStore).offDays, (offDay) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ExcludedDayItem_vue_1.default, {
                                id: offDay.id,
                                key: offDay.id,
                                date: offDay.date,
                                onDecline: ($event) => ((0, vue_2.unref)(offDaysStore).deleteDate(offDay.id))
                            }, null, 8, ["id", "date", "onDecline"]));
                        }), 128))
                    ])
                ])
            ], 64));
        };
    }
});
